export default __webpack_public_path__ + "static/realvision-58190f414007169f6ade9de2e5f9f33f.jpg";